import * as React from 'react'

import { observer } from 'mobx-react'
import { LinkItEmail, LinkItUrl } from 'react-linkify-it'

interface IProps {
  value?: string
  children?: React.ReactNode
  linkClassName?: string
}

function Linkifier({ value, children, linkClassName }: IProps) {
  return (
    <LinkItUrl className={linkClassName}>
      <LinkItEmail className={linkClassName}>{value || children}</LinkItEmail>
    </LinkItUrl>
  )
}

export default observer(Linkifier)
